<div class="generic-confirm-modal">
  <div class="generic-confirm-modal__body">
    <p data-testid="awaiting-signer-acknowledgement-message" class="generic-confirm-modal__p">
      All documents have been signed. Please ask the signers to acknowledge and submit on their screen.
    </p>
  </div>
</div>